import { deattribute } from './deattribute.mjs';
import { filterIncludes } from './filterIncludes.mjs';
import './error.mjs';

function link({
  id,
  type,
  meta
}, included, previouslyLinked) {
  const filtered = filterIncludes(included, {
    id,
    type
  });
  previouslyLinked[`${type}#${id}`] = filtered;

  if (filtered.relationships) {
    linkRelationships(filtered, included, previouslyLinked);
  }

  if (meta) filtered.meta = meta;
  return deattribute(filtered);
}

function linkArray(data, included, key, previouslyLinked) {
  data[key] = {};
  if (data.relationships[key].links) data[key].links = data.relationships[key].links;
  data[key].data = [];

  for (const resource of data.relationships[key].data) {
    const cache = previouslyLinked[`${resource.type}#${resource.id}`];
    data[key].data.push(cache || link(resource, included, previouslyLinked));
  }

  delete data.relationships[key];
}

function linkObject(data, included, key, previouslyLinked) {
  data[key] = {};
  const resource = data.relationships[key].data;
  const cache = previouslyLinked[`${resource.type}#${resource.id}`];
  data[key].data = cache || link(resource, included, previouslyLinked);
  if (data.relationships[key].links) data[key].links = data.relationships[key].links;
  delete data.relationships[key];
}

function linkAttr(data, key) {
  data[key] = {};
  if (data.relationships[key].links) data[key].links = data.relationships[key].links;
  delete data.relationships[key];
}

function linkRelationships(data, included = [], previouslyLinked = {}) {
  const {
    relationships
  } = data;

  for (const key in relationships) {
    var _relationships$key;

    if (Array.isArray((_relationships$key = relationships[key]) === null || _relationships$key === void 0 ? void 0 : _relationships$key.data)) {
      linkArray(data, included, key, previouslyLinked);
    } else if (relationships[key].data) {
      linkObject(data, included, key, previouslyLinked);
    } else {
      linkAttr(data, key);
    }
  }

  if (Object.keys(relationships || []).length === 0 && (relationships === null || relationships === void 0 ? void 0 : relationships.constructor) === Object) {
    delete data.relationships;
  }

  return data;
}

export { linkRelationships };
